<template>
  <div class="container mb-5">
    <div class="row mb-5 my-md-5">
      <div class="col-sm-6 offset-sm-3">
        <h1 class="text-center">
          {{ $t("comissao") }}
        </h1>
      </div>
    </div>
    <ComissaoTable />
  </div>
</template>

<script>
import ComissaoTable from './components/ComissaoTable.vue';

export default {
  components: { ComissaoTable },
};
</script>
